/* eslint-disable */
import { AUTH_OKTA_TRANSACTION_SUCCESS } from '../../Services/Auth/Adapter/Okta/AuthOkta.adapter.constants';
import stripIndent from '../../Vendor/strip-indent';

/**
 * Called when the `transaction` returned from logging in is unknown
 * @export
 * @class AuthOktaUnknownTransactionTypError
 * @extends {Error}
 */
export class AuthOktaUnknownTransactionTypError extends Error {
  /**
   * Creates an instance of AuthOktaUnknownTransactionTypError
   * @param {string} message The Error `message`
   * @memberof AuthOktaUnknownTransactionTypError
   */
  constructor(message) {
    super(message);
    this.name = `AuthOktaUnknownTransactionTypError`;
  }
}

/**
 * Called when the `transaction` returned from logging in is unknown
 * @param {any} status The invalid `status`
 * @param {Error} [error] The error that was encounted
 * @returns {never} never
 */
const throwAuthOktaUnknownTransactionTypeError = (status, error) => {
  if (error !== undefined) {
    throw new AuthOktaUnknownTransactionTypError(
      stripIndent(`
      Expected "transaction.status" to be "${AUTH_OKTA_TRANSACTION_SUCCESS}".
      Got: "${status}" ${error.message}"
    `),
    );
  }
  throw new AuthOktaUnknownTransactionTypError(
    stripIndent(`
    Expected "transaction.status" to be "${AUTH_OKTA_TRANSACTION_SUCCESS}".
    Got: "${status}"
    `),
  );
};

export default throwAuthOktaUnknownTransactionTypeError;
